<ion-content class="employee-cancel">
    <ng-container>
        <app-header [title]="header"></app-header>
        <div class="loading-container"  *ngIf="!loaded">
          <ion-spinner></ion-spinner>
        </div>
        <div  class="cancel-container">
           <ion-row>
                <ion-grid class="inner-grid">
                    <ion-row>
                        <ion-col>
                            <ion-row>
                              <ion-col>Cust: &nbsp;&nbsp;{{customerId}} <strong> &nbsp;&nbsp;{{customerName}}</strong></ion-col>
                            </ion-row>
                            <ion-row>
                              <ion-col>Dept: &nbsp;&nbsp;{{Dept}} <strong> &nbsp;&nbsp;{{departmentName}}</strong> </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col>Emp: &nbsp;&nbsp;{{employeeCode}}  <strong> &nbsp;&nbsp;{{cancelOrders?.[0]?.[0]?.lastName}}, {{cancelOrders?.[0]?.[0]?.firstName}} ({{cancelOrders?.[0]?.[0]?.deliveryAddress1 }})</strong></ion-col>
                            </ion-row>
                    
                            </ion-col>  
                        <ion-col>
                               <div style="float:right">
                                    <ion-row >
                                        Report Date: {{ currentDate  | date:'MM/dd/yyyy'}}
                                    </ion-row>
                                     <ion-row style="margin-top:10px">
                                       <button class="printer-button hidden-for-print" (click)="changePrinterView()">{{viewChange === true ? 'Regular Version' : 'Printer Friendly Version'}}</button>
                                    </ion-row>
                                </div>
                       </ion-col>         
                      </ion-row>
                   
                </ion-grid>
            </ion-row>
            <ion-grid *ngFor="let wo of cancelOrders" class="main-grid">
                <ion-row>
                    <ion-col class="bold">
                        {{wo[0].lastName}}, {{wo[0].firstName}} ({{wo[0].deliveryAddress1 }})
                    </ion-col>
                    <ion-col>
                        <strong>Cancel Order:</strong> {{wo[0].woCode}}
                    </ion-col>
                    <ion-col>
                        <strong>Start Date:</strong> {{wo[0].orderDate | date: 'MM/dd/yyyy'}}
                    </ion-col>
                </ion-row>
                <ion-row class="ion-justify-content-end ion-align-items-center">
                    <ion-col class="ion-justify-content-end ion-align-items-center">
                        <strong>Stop:</strong> {{wo[0].stopName}}
                    </ion-col>
                    <ion-col class="ion-justify-content-end ion-align-items-center">
                        <strong>Gar. ID Label:</strong> {{wo[0].stopCode}} {{wo[0].lockerNum}}
                    </ion-col>
                </ion-row>
                <ion-grid class="data-grid">
                    <ion-row class="data-headers">
                      <ion-col size="2.1">
                        <strong>Description</strong>
                      </ion-col>
                      <ion-col size="4.2">
                        <strong>Product</strong>
                      </ion-col>
                      <ion-col size="2.1">
                        <strong>Barcode #</strong>
                      </ion-col>
                      <ion-col size="2.1">
                        <strong>Date Collected</strong>
                      </ion-col>
                      <ion-col size="1.5" style="text-align: right;">
                        <strong>Loss Charge</strong>
                      </ion-col>
                    </ion-row>
    
                    <ion-row *ngFor="let item of wo">
                      <ion-col size="2.1">
                        {{item.description}}
                      </ion-col>
                      <ion-col size="4.2">
                        {{item.product}}
                      </ion-col>
                      <ion-col size="2.1">
                        {{item.barcode}}
                      </ion-col>
                      <ion-col size="2.1">
                        {{item.dateCollected === null ? 'Not Collected' : item.dateCollected | date: 'MM/dd/yyyy'}}
                      </ion-col>
                      <ion-col size="1.5" style="text-align: right;">
                        {{item.dateCollected === null ? (item.lossCharge | currency: 'USD') : '$0.00'}}
                      </ion-col>
                    </ion-row>
                    <ion-row class="data-footer">
                        <ion-col size="10">
                               <strong>Final Pickup Date and Potential Charges: {{wo[0].pickUpDate | date: 'shortDate'}}</strong> 
                        </ion-col>
                        
                        <ion-col size="2" style="text-align: right;">
                            <strong>{{wo.lossCharge | currency:'USD':'symbol':'1.2-2'}}</strong>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-grid>
            <ion-grid *ngIf="cancelOrders.length!=0">
                <ion-row class="grand-total">
                    <ion-col size="10">
                        <strong>Grand Total Potential Loss Charge</strong>
                    </ion-col>
                    <ion-col size="2" style="text-align: right;">
                        <strong>{{totalLossCharge | currency:'USD':'symbol':'1.2-2'}}</strong>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
        <ion-row class="no-work-orders" *ngIf="loaded && (cancelOrders.length <= 0)">
                <ion-col>
                    No cancel Orders
                </ion-col>
            </ion-row>
    </ng-container>
</ion-content>